export class generate270
{
    groupId:string="00000000-0000-0000-0000-000000000000";
    payorId:string="00000000-0000-0000-0000-000000000000";
    companyId:string="00000000-0000-0000-0000-000000000000";
    clearingHouseId:string="00000000-0000-0000-0000-000000000000";
}


export class Getview270BO {
   

      orderColumn: string = "createDate";
    orderType: string = "desc";
    pageitem: number=10;
    currentpageno: number = 1;
    listId: number;
    field: string = "createDate";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    agencyID: number;
    type: string = "date";
}

export class ColumnChangeBO {
    id: number=0;
    userid: number=0;
    agencyId: number=0;
    column: string;
}export class reutrn270 {
    fileName: string;
    payerDetail: PayerDetail;
    companyDetail: CompanyDetail;
    clinetDetail: ClinetDetail[];
    clearingHouseDetail: clearinghouseBO;
    eligibility270Id: number;
    created_Date: string;
    filePath:string;
    folderName:string;
}

export class _270BO {
    clearingHouseDetail: clearinghouseBO;
    reciverDetail: Reciver[];
    batchnumber: string;
}export class Reciver {
    payerDetail: PayerDetail;
    subscriberDetails: subscriber[];
}

export class clearinghouseBO {
    receiverId: string;
    clearingHouseName: string;
    receiver_Qualifier: string;
    clearingHouseId: string;
    senderId: string;
    sender_Qualifier: string;
}
export class subscriber {
    companyDetail: CompanyDetail;
    clinetDetail: ClinetDetail[];
}
export class PayerDetail {
    payer_Name: string;
    payer_Address_1: string;
    payer_Address_2: string;
    payer_City: string;
    payer_State: string;
    payer_Zip: string;
    payer_FEIN: string;
    billing_payor_ID: string;
    renderingProviderID: boolean;
    providerNo: string;
    _837I_Ins_ID: string;
    companyFEIN: string;
    claim_Filling_Ind: string;
    aTYPICAL: boolean;
    payorId: number | null;
}

export class ClinetDetail {
    clinet_FirstName: string;
    clinet_LastName: string;
    cLient_MiddleName: string;
    clinet_Address_1: string;
    clinet_Address_2: string;
    clinet_City: string;
    clinet_State: string;
    clinet_Zip: string;
    service_AgreementNo: string;
    client_Insurance: string;
    client_DOB: string;
    client_Gender: string;
}
export class CompanyDetail {
    senderId: string;
    sender_Qualifier: string;
    company_Name: string;
    response_Contact_Name_Or_Organization_Name: string;
    company_PhoneNumber: string;
    company_ProviderNo: string;
    company_Address_1: string;
    company_Address_2: string;
    company_City: string;
    company_State: string;
    company_Zip: string;
}

export class EDI271BO {
    fileName: string;
    unique271ISA: string;
    importedDate: string;
    interchangeDateTime: string;
    sender_EntityIdentifier: string;
    sender_Name: string;
    sender_IdQualifier: string;
    sender_Id: string;
    sender_ContactName: string;
    sender_CommunicationNumberQualifier1: string;
    sender_CommunicationNumber1: string;
    sender_CommunicationNumberQualifier2: string;
    sender_CommunicationNumber2: string;
    sender_CommunicationNumberQualifier3: string;
    sender_CommunicationNumber3: string;
    receiver_EntityIdentifier: string;
    receiver_Name: string;
    receiver_IdQualifier: string;
    receiver_Id: string;
    receiver_AddressLine1: string;
    receiver_AddressLine2: string;
    receiver_City: string;
    receiver_StateCode: string;
    receiver_ZipCode: string;
    _271Source: string;
    clients: EDI271ClientBO[];
}

export class EDI271ClientBO {
    clientIdQualifier: string;
    clientID: string;
    clientName: string;
    addressLine1: string;
    addressLine2: string;
    aaaDetails:EDI271AAADetailBO[];
    city: string;
    state: string;
    zipCode: string;
    dOB: string;
    gender: string;
    loopDetails: EDI271LoopDetailBO[];
    aAADetails: EDI271AAADetailBO[];
    medicaid:string;
    clientPkId:string;
}

export class EDI271LoopDetailBO {
    eligibilityorBenefitInformation: string;
    benefitCoverageLevel: string;
    serviceType: string;
    insuranceType: string;
    planCoverageDescription: string;
    timePeriodQualifier: string;
    benefitAmount: number | null;
    benefitPercent: number | null;
    quantityQualifier: string;
    benefitQuantity: string;
    authorizationorCertificationIndicator: string;
    inPlanNetwork: string;
    cmp_ProductorServiceIDQualifier: string;
    cmP_ProductorServiceIDQualifier:string
    cmp_ProcedureCode: string;
    cmP_ProcedureCode:string;
    cmp_ProcedureModifiers: string;
    cmP_ProcedureModifiers: string;
    cmp_Description: string;
    cmP_Description:string;
    cmp_ProductServiceID: string;
    cmP_ProductServiceID:string
    diagnosisCodePointers: string;
    messages: string;
    dtpDetails: EDI271DtpDetailBO[];
}

export class EDI271AAADetailBO {
    validRequest: string;
    agencyQualifier: string;
    rejectReason: string;
    followupAction: string;
}

export class EDI271DtpDetailBO {
    dateTimeQualifier: string;
    dateTimePeriod: string;
}
export class GetEligibilityLogsBo {
    employeeId: string ="00000000-0000-0000-0000-000000000000";
    clientId: string ="00000000-0000-0000-0000-000000000000";
    fromDate: string | null;
    toDate: string | null;
    searchColumn: string = "companyName";
    searchText: string = "";
    agencyID: string ="00000000-0000-0000-0000-000000000000";
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "companyName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "companyName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    locationID: string ="00000000-0000-0000-0000-000000000000";
    startDate: string | null;
    endDate: string | null;
    edi_Status: string;
    transaction_Status=null;
}

export class GetEligibility271 {
    employeeId: string ="00000000-0000-0000-0000-000000000000";
    clientId: string ="00000000-0000-0000-0000-000000000000";
    fromDate: string | null;
    toDate: string | null;
    searchColumn: string = "companyName";
    searchText: string = "";
    agencyID: string ="00000000-0000-0000-0000-000000000000";
    currentpageno: number = 1;
    pageitem: number = 250;
    orderColumn: string = "companyName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "companyName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    locationID: string ="00000000-0000-0000-0000-000000000000";
    startDate: string | null;
    endDate: string | null;
    edi_Status: string;
    transaction_Status=null;
}



export class FilterLogsBo
{
FromDate:string=null;
ToDate:string=null;
edi_Status:string=null;
transaction_Status=null;
}

export class ApplyFilter271
{
FromDate:string=null;
ToDate:string=null;
edi_Status:string=null
transaction_Status=null;

}


